import * as React from "react";
import BasicCard from "myshubhlife-component/card";
import {Loan} from "Loans/interface";
import Button from "myshubhlife-component/button";
import {CardRow} from "Loans/utils";
import {imageBaseUrl, websiteUrl} from "config";
import {connect} from "react-redux";
import {notifyDownload, setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {getIdToken} from "service";
import {CC_EMAIL_ID, COLOR} from "utils/variables";
import {downloadEkagrataNoc} from "Loans/api";
import {downloadPdfFromBase64} from "utils/download";
import {Modal} from "web-com";
import {LenderName} from "utils/lenderDetails";
import "./styles.scss";
import {partnerOfferings} from "login/config";

interface RlocProps {
  rlocInfo: Loan;
  index: number;
}

interface IConnectProps {
  dispatch?: (action: any) => void;
  loanIndex: number;
  isAndroid: boolean;
  apiVersion: number;
  authExt: {[key: string]: string};
  utm_source?: string;
}

interface DownloadNocStatusPopover {
  active: boolean;
  downloadSuccess: boolean;
  cardAction: () => void;
}

export enum DownloadNocStatus {
  PENDING = "pending",
  SUCCESS = "success",
  FAILED = "failed",
}

const redirectToMayaLoans = (isAndroid: boolean, apiVersion: number, loanId: number, params?: string) => {
  if (!isAndroid) {
    if (params) return window.open(`${websiteUrl}/loans/#/${loanId}?${params}`, "_self");
    return window.open(`${websiteUrl}/loans/#/${loanId}`, "_self");
  }
  const token = getIdToken();
  setAndroidTokenAndVersionBeforeRedirecting(apiVersion, token);
  if (params) return window.open(`${websiteUrl}/loans/#/${loanId}?id_token=${token}&${params}`, "_self");
  return window.open(`${websiteUrl}/loans/#/${loanId}?id_token=${token}`, "_self");
}

const getAllQueryParams = (authExt) => {
  let allQuery;
    if (authExt && Object.keys(authExt).length) {
        allQuery = Object.keys(authExt)
            .map((key) => `${key}=${authExt[key]}`)
            .join("&");
    }
  return allQuery;
}

const Rloc = (props: RlocProps & IConnectProps) => {
  const [nocDownloadedStatus, setNocDownloadedStatus] = React.useState<DownloadNocStatus>();

  const handleIndex = () => {
    return redirectToMayaLoans(props.isAndroid, props.apiVersion, props.rlocInfo.loan_id, getAllQueryParams(props.authExt));
  };

  const repayment = () => {
    return redirectToMayaLoans(props.isAndroid, props.apiVersion, props.rlocInfo.loan_id, `repay=true&${getAllQueryParams(props.authExt)}`);
  };

  const outstandingAmount = props.rlocInfo.state['bills'].map(bill => bill.balance).reduce((prev, next) => prev + next, 0);

  const withdraw = () => {
    return redirectToMayaLoans(props.isAndroid, props.apiVersion, props.rlocInfo.loan_id, `withdraw=true&${getAllQueryParams(props.authExt)}`);
  };

  const handleDownloadNOC = async () => {
    if (nocDownloadedStatus === DownloadNocStatus.PENDING) return;
    try {
      setNocDownloadedStatus(DownloadNocStatus.PENDING);
      const res = await downloadEkagrataNoc(props.rlocInfo.loan_id);
      if (props.isAndroid) {
        notifyDownload(res.fileName, res.pdfData, null, "application/pdf");
      } else {
        downloadPdfFromBase64(res.pdfData, res.fileName);
      }
      setNocDownloadedStatus(DownloadNocStatus.SUCCESS);
    } catch (err) {
      setNocDownloadedStatus(DownloadNocStatus.FAILED);
    }
  };

  return (
    <div className="rloc-container">
      <NocDownloadPopover
        active={nocDownloadedStatus && nocDownloadedStatus !== DownloadNocStatus.PENDING}
        cardAction={() => setNocDownloadedStatus(undefined)}
        downloadSuccess={nocDownloadedStatus === DownloadNocStatus.SUCCESS}
      />
      <BasicCard
        headerBackgroundColor={partnerOfferings[props.utm_source]?.colors?.white}
        headerTitle={`RLOC-${props.rlocInfo.state['loan_detail']['loanDetail']['lenderLoanAcctId']}`}
        headerTextColor={partnerOfferings[props.utm_source]?.colors?.green}
        key={props.rlocInfo.loan_id}
        addtionalField={
          <Button
            buttonText="Details"
            maxWidth={95}
            height={30}
            bgColor={COLOR.WHITE}
            textColor={partnerOfferings[props.utm_source]?.colors ? partnerOfferings[props.utm_source]?.colors?.green : COLOR.PRIMARY}
            onClick={handleIndex}
          />
        }
      >
        <div className="details-container">
            <CardRow title="Total Limit" value={`₹ ${props.rlocInfo.state['available_limit'].toFixed(2)}`} />
            <CardRow title="Total Outstanding" value={`₹ ${outstandingAmount.toFixed(2)}`} />
            <CardRow
              title="Due Date"
              value="5th of every month"
            />
          <div className="rloc-btn-container">
          {!props.rlocInfo.state["is_closed"]
          ? <div className="active-loan-btn">
              <Button
                bgColor={partnerOfferings[props.utm_source]?.colors?.green}
                buttonText="Repay"
                maxWidth={95}
                height={30}
                onClick={repayment}
              />
              <Button
                bgColor={partnerOfferings[props.utm_source]?.colors?.blue}
                buttonText="Withdraw"
                maxWidth={95}
                height={30}
                onClick={withdraw}
              />
            </div>
          : <div className="closed-loan-btn">
              {
                props.rlocInfo.state.loan_detail.loanDetail.lenderId === LenderName.EKAGRATA
                ? <Button
                    buttonText="Download Noc"
                    onClick={handleDownloadNOC} 
                    maxWidth={140}
                    height={40}
                  />
                : "Contact customer support"
              }
            </div> 
          }
          </div>
        </div>
      </BasicCard>
    </div>
  );
};


const NocDownloadPopover = ({
  active,
  cardAction,
  downloadSuccess,
}: DownloadNocStatusPopover) => {
  return (
    <Modal active={active} onCloseHandler={cardAction}>
      <img
        className="noc-download-status-img"
        src={`${imageBaseUrl}/img/${
          downloadSuccess ? "noc-download-success" : "noc-download-failed"
        }.svg`}
        alt={`Download ${downloadSuccess ? "Success" : "Failed"}`}
      />
      <span className="noc-status-text">
        {downloadSuccess ? "Success" : "Download has Failed!."}
        {!downloadSuccess && (
          <span className="noc-status-info">
            Please reach <span className="msl-mail">
              <a className="contact-link" href={`mailto:${CC_EMAIL_ID}`}> {CC_EMAIL_ID} </a>
            </span>
          </span>
        )}
      </span>
      <Button
        rounded
        buttonText="Okay"
        maxWidth={95}
        height={40}
        onClick={cardAction}
      />
    </Modal>
  );
};

const mapStateToProps = (state): IConnectProps => {
  return {
      loanIndex: state.loanDetails['loanIndex'] ? state.loanDetails['loanIndex']: null,
      isAndroid: state.login.isAndroid,
      apiVersion: state.login.apiVersion,
      authExt: state.login.authExt,
      utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(Rloc);
